import type { ReactNode } from "react";
import { cn } from "../../utils/common/cn";
import type { AsOfPage } from "../../pages/PortfolioPerformance/lib/api/as-of";
import { AsOfCard } from "./as-of-card";

interface PageHeaderProps {
  title: string;
  subtitle?: string;
  eyebrow?: string;
  right?: ReactNode;
  /** Shows the date the page's cards are as of, top right above the divider. For the pages whose cards are compared with an earlier month. */
  asOfPage?: AsOfPage;
  className?: string;
}

export function PageHeader({
  title,
  subtitle,
  eyebrow = "Athena · Portfolio Performance",
  right,
  asOfPage,
  className,
}: PageHeaderProps) {
  return (
    <div
      className={cn(
        "flex flex-col gap-4 border-b border-border pb-6 sm:flex-row sm:items-end sm:justify-between",
        className,
      )}
    >
      <div className="min-w-0 space-y-2">
        <p className="text-[0.7rem] font-semibold uppercase tracking-[0.18em] text-primary">
          {eyebrow}
        </p>
        <h1 className="text-2xl font-semibold tracking-tight text-foreground md:text-3xl">
          {title}
        </h1>
        {subtitle ? (
          <p className="text-sm leading-relaxed text-muted-foreground">{subtitle}</p>
        ) : null}
      </div>
      {right || asOfPage ? (
        <div className={cn("flex shrink-0 gap-2", asOfPage ? "items-end gap-3" : "items-center")}>
          {right}
          {asOfPage ? <AsOfCard page={asOfPage} /> : null}
        </div>
      ) : null}
    </div>
  );
}
